import React, { useEffect, useState } from "react";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import EditIcon from "@mui/icons-material/Edit";
import { ModalClienteEquip } from "./ModalClienteEquip";
import { useSelector } from "react-redux";

export const ClienteEquipScreen = ({ setLoading }) => {
  const { clienteselected, idcliente } = useSelector((store) => store.clientes);
  const [lista, setLista] = useState([]);
  const [selected, setSelected] = useState(null);
  const openModal = (value) => {
    var modal = document.getElementById("modal-contacto");
    modal.style.display = "block";
    setSelected(value);
  };
  useEffect(() => {
    if (
      idcliente === undefined ||
      idcliente === null ||
      idcliente === 0 ||
      idcliente === "0" ||
      idcliente === "" ||
      idcliente === "-1" ||
      idcliente === "-1"
    ) {
      return;
    }
    setLoading(true);
    request
      .get(`ClientesEQUIP/Listado?idcliente=${Number(idcliente)}`)
      .then((result) => {
        setLoading(false);
        setLista(result);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, []);
  const eliminarregistro = (idequip) => {
    Swal.fire({
      title: "Deseas eliminar el registro?",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      confirmButtonText: "Save",
      cancelButtonText: "Cancelar",
      denyButtonText: `Eliminar`,
    }).then((result) => {
      if (result.isDenied) {
        setLoading(true);
        request
          .get(
            `ClientesEQUIP/Eliminar?idcliente=${Number(
              idcliente
            )}&idequip=${Number(idequip)}`
          )
          .then((result) => {
            setLoading(false);
            setLista(result);
          })
          .catch((error) => {
            setLoading(false);
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    });
  };
  if (
    idcliente === undefined ||
    idcliente === null ||
    idcliente === 0 ||
    idcliente === "0" ||
    idcliente === "" ||
    idcliente === "-1" ||
    idcliente === "-1"
  ) {
    return <div>Favor de seleccionar un cliente</div>;
  }
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <>
      <div className="clientes-equip-header">
        <ModalClienteEquip setListado={setLista} element={selected} />
        <div className="clientes-equip-titulo">{capitalizeWords(clienteselected)}</div>
        <div className="clientes-equip-agregar" onClick={() => openModal(null)}>
          Agregar
        </div>
      </div>
      <div className="clientes-equip-container scroll-4">
        {lista === undefined || lista === null || lista.length === 0 ? (
          <div>Sin datos registrados</div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>EQUIP</th>
                <th>Sucursal</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lista.map((lst) => (
                <tr>
                  <td>{lst.idequip}</td>
                  <td>{capitalizeWords(lst.sucursal)}</td>
                  <td>
                    <EditIcon onClick={() => openModal(lst)} />
                  </td>
                  <td>
                    <DeleteIcon onClick={() => eliminarregistro(lst.idequip)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};
